import React from 'react';
import { CheckCircle } from 'lucide-react';

const steps = [
  {
    number: 1,
    title: 'ฝากเงินเข้ากระเป๋าเว็บไซต์',
    description:
      'โอนจากกระเป๋า Digital (MetaMask) เข้ากระเป๋า Mungkorn Lotto',
  },
  {
    number: 2,
    title: 'เลือกเลขโชคดี',
    description:
      'เลือกเลข 6 หลัก / 3 ตัว / 2 ตัว — ตั๋วใบละ $1',
  },
  {
    number: 3,
    title: 'ซื้อตั๋วและรอลุ้นรางวัล',
    description:
      'ยืนยันการซื้อด้วยยอดในกระเป๋า แล้วรอผลรางวัลทุกงวด',
  },
];

export function HowItWorks() {
  return (
    <div className="rounded-2xl border border-red-100 bg-white p-6 shadow-sm sm:p-8">
      <div className="mb-8 flex items-center gap-3 border-b border-red-100 pb-4">
        <CheckCircle className="h-8 w-8 text-brand-gold" />
        <h2 className="text-xl font-bold text-brand-red sm:text-2xl">
          วิธีเล่น Mungkorn Lotto
        </h2>
      </div>
      <div className="grid grid-cols-1 gap-6 md:grid-cols-3">
        {steps.map((step) => (
          <div
            key={step.number}
            className="relative flex gap-4 rounded-xl border-2 border-brand-red bg-gradient-to-br from-white to-red-50/50 p-5"
          >
            <div className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-brand-red text-xl font-bold text-white">
              {step.number}
            </div>
            <div>
              <h3 className="font-bold text-brand-red">{step.title}</h3>
              <p className="mt-2 text-sm text-gray-600">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
